var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ALIGN, SPACE, styles, useDevice } from '../../../hooks';
import { View } from '../../primitives';
import { style } from './Layout.style';
const Layout = (_a) => {
    var { children, alignItems = ALIGN.START, fullWidth, inline = true, justifyContent = ALIGN.BETWEEN, reverse } = _a, others = __rest(_a, ["children", "alignItems", "fullWidth", "inline", "justifyContent", "reverse"]);
    const { screen } = useDevice();
    return (React.createElement(View, Object.assign({}, others, { alignItems: alignItems, justifyContent: justifyContent, paddingHorizontal: !fullWidth ? (screen.S ? SPACE.SPACE_6 : SPACE.SPACE_10) : undefined, style: styles(style.layout, inline ? style.row : style.column, reverse && (inline && !screen.S ? style.reverse : style.reverseColumn), fullWidth && style.fullWidth, others.style), wide: true }), children));
};
Layout.displayName = 'Layout';
export { Layout };
